import React, { useState } from 'react';
import './Settings.css';

function Settings() {
  const [settings, setSettings] = useState({
    notifications: true,
    darkMode: false,
    language: 'zh_CN',
    fontSize: 'medium'
  });

  const handleToggleChange = (setting) => {
    setSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
  };

  const handleSelectChange = (setting, value) => {
    setSettings(prev => ({
      ...prev,
      [setting]: value
    }));
  };

  const handleSaveSettings = () => {
    // 这里可以添加保存设置的逻辑
    alert('设置已保存');
  };

  return (
    <div className="settings-page">
      <h2>系统设置</h2>
      
      <div className="settings-container">
        <div className="settings-section">
          <h3>通用设置</h3>
          
          <div className="setting-item">
            <div className="setting-label">通知提醒</div>
            <div className="setting-control">
              <label className="toggle">
                <input 
                  type="checkbox" 
                  checked={settings.notifications}
                  onChange={() => handleToggleChange('notifications')}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
          
          <div className="setting-item">
            <div className="setting-label">深色模式</div>
            <div className="setting-control">
              <label className="toggle">
                <input 
                  type="checkbox" 
                  checked={settings.darkMode}
                  onChange={() => handleToggleChange('darkMode')}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
          
          <div className="setting-item">
            <div className="setting-label">语言</div>
            <div className="setting-control">
              <select 
                value={settings.language}
                onChange={(e) => handleSelectChange('language', e.target.value)}
              >
                <option value="zh_CN">简体中文</option>
                <option value="en_US">English (US)</option>
                <option value="ja_JP">日本語</option>
              </select>
            </div>
          </div>
          
          <div className="setting-item">
            <div className="setting-label">字体大小</div>
            <div className="setting-control">
              <select 
                value={settings.fontSize}
                onChange={(e) => handleSelectChange('fontSize', e.target.value)}
              >
                <option value="small">小</option>
                <option value="medium">中</option>
                <option value="large">大</option>
              </select>
            </div>
          </div>
        </div>
        
        <div className="settings-section">
          <h3>账户安全</h3>
          
          <div className="setting-item">
            <div className="setting-label">修改密码</div>
            <div className="setting-control">
              <button className="setting-btn">修改</button>
            </div>
          </div>
          
          <div className="setting-item">
            <div className="setting-label">绑定手机</div>
            <div className="setting-control">
              <button className="setting-btn">绑定</button>
            </div>
          </div>
          
          <div className="setting-item">
            <div className="setting-label">两步验证</div>
            <div className="setting-control">
              <button className="setting-btn">设置</button>
            </div>
          </div>
        </div>
        
        <div className="settings-actions">
          <button className="save-btn" onClick={handleSaveSettings}>保存设置</button>
          <button className="reset-btn">恢复默认</button>
        </div>
      </div>
    </div>
  );
}

export default Settings; 